import { $t } from 'hooks/i18n';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { CanView } from 'components/Can';
import { Chip } from 'primereact/chip';
import { Column } from 'primereact/column';
import { DataSource } from 'components/DataSource';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { PageRequestError } from 'components/PageRequestError';
import { Paginator } from 'primereact/paginator';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';
import DepositproductViewPage from 'pages/depositproduct/View';
import LoangroupViewPage from 'pages/loangroup/View';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
import MasterDetailPages from './MasterDetailPages';
const DepositesListPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const utils = useUtils();
	const filterSchema = {
		search: {
			tagTitle: $t('search'),
			value: '',
			valueType: 'single',
			options: [],
		},
		policydate: {
			tagTitle: $t('policydate'),
			value: [],
			valueType: 'range-date',
			options: [],
		},
		branchcode: {
			tagTitle: $t('branchcode'),
			value: '',
			valueType: 'single',
			options: [],
		},
		groupid: {
			tagTitle: $t('groupid'),
			value: '',
			valueType: 'single',
			options: [],
		},
		empcode: {
			tagTitle: $t('empcode'),
			value: '',
			valueType: 'single',
			options: [],
		},
		maturitydate: {
			tagTitle: $t('maturitydate'),
			value: [],
			valueType: 'range-date',
			options: [],
		},
		date_closed: {
			tagTitle: $t('dateClosed'),
			value: [],
			valueType: 'range-date',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, apiUrl, currentRecord, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, setCurrentRecord, pagination } = pageController;
	const { filters, setFilterValue, setFilterOptions } = filterController;
	const { totalRecords, totalPages, recordsPosition, firstRow, limit, onPageChange } =  pagination;
	function ActionButton(data){
		const items = [
		{
			label: $t('view'),
			command: (event) => { app.navigate(`/deposites/view/${data.policyno}`) },
			icon: "pi pi-eye",
			visible: () => auth.canView('deposites/view')
		},
		{
			label: $t('edit'),
			command: (event) => { app.navigate(`/deposites/edit/${data.policyno}`) },
			icon: "pi pi-pencil",
			visible: () => auth.canView('deposites/edit')
		},
		{
			label: $t('delete'),
			command: (event) => { deleteItem(data.policyno) },
			icon: "pi pi-trash",
			visible: () => auth.canView('deposites/delete')
		}
	]
	.filter((item) => {
		if(item.visible){
			return item.visible()
		}
		return true;
	});
		return (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />);
	}
	function PolicynoTemplate(data){
		if(data){
			return (
				<Link to={`/deposites/view/${data.policyno}`}> { data.policyno }</Link>
			);
		}
	}
	function MembernameTemplate(data){
		if(data){
			return (
				<>{ data.depositlookup_membername }</>
			);
		}
	}
	function PolicydateTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.policydate )}</>
			);
		}
	}
	function MaturitydateTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.maturitydate )}</>
			);
		}
	}
	function EmpnameTemplate(data){
		if(data){
			return (
				<>{ data.depositlookup_empname }</>
			);
		}
	}
	function AcClosedTemplate(data){
		if(data){
			return (
				<><Chip
   label={
   String(data.ac_closed || null).trim().toUpperCase() === "ACTIVE"
   ? "🟢 ACTIVE"
   : "🔴 CLOSED"
    }
/></>
			);
		}
	}
	function CreatedAtTemplate(data){
		if(data){
			return (
				<>{utils.humanDatetime( data.created_at )}</>
			);
		}
	}
	function UpdatedAtTemplate(data){
		if(data){
			return (
				<>{utils.humanDatetime( data.updated_at )}</>
			);
		}
	}
	function ProductidTemplate(data){
		if(data){
			return (
				<>{data.productid && <Button className="p-button-text" icon="pi pi-eye" label={$t('depositproduct')} onClick={() => app.openPageDialog(<DepositproductViewPage isSubPage apiPath={`/depositproduct/view/${data.productid}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function GroupidTemplate(data){
		if(data){
			return (
				<>{data.groupid && <Button className="p-button-text" icon="pi pi-eye" label={$t('loangroup')} onClick={() => app.openPageDialog(<LoangroupViewPage isSubPage apiPath={`/loangroup/view/${data.groupid}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function MasterDetailBtnTemplate(data){
		if(data){
			return (
				<><Button className="p-button-text" onClick={()=>setCurrentRecord(data)} icon="pi pi-caret-down" label="" /></>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">{$t('loading')}</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					{$t('noRecordFound')}
				</div>
			);
		}
	}
	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title={$t('deleteSelected')}/>
				</div>
			)
		}
	}
	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-deposites`;
			return (
				<div className="m-2">
					<ExportPageData  pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel={$t('')} tooltip={$t('export')} buttonIcon="pi pi-print" />
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
		const pagerReportTemplate = {
			layout: pagination.layout,
			CurrentPageReport: (options) => {
				return (
					<>
						<span className="text-sm text-gray-500 px-2">{$t('records')} <b>{ recordsPosition } {$t('of')} { options.totalRecords }</b></span>
					</>
				);
			}
		}
		return (
			<div className="flex-grow-1">
				<Paginator first={firstRow} rows={limit} totalRecords={totalRecords}  onPageChange={onPageChange} template={pagerReportTemplate} />
			</div>
		)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
	<CanView pagePath="deposites/delete">
		<MultiDelete />
	</CanView>
				<ExportData />
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="DepositesListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title={$t('deposites')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-fixed " >
                    <Link to={`/deposites/add`}>
                        <Button label={$t('addNewDeposit')} icon="pi pi-plus" type="button" className="p-button w-full bg-primary "  />
                        </Link>
                    </div>
                    <div className="col-12 md:col-3 " >
                        <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" />
                        <InputText placeholder={$t('search')} className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                        </span>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="p-3 mb-3">
                            <div className="">
                                <Calendar showIcon={true} showButtonBar={true} dateFormat="yy-mm-dd" hourFormat="24" className="w-full" selectionMode="range" value={filters.policydate.value} onChange={(e) => setFilterValue('policydate', e.value)} placeholder={$t('selectDate')}   />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="p-3 mb-3">
                            <DataSource onLoad={(options) => setFilterOptions('branchcode', options)}  apiPath="components_data/branchcode_option_list_2"  >
                                {
                                ({ response }) => 
                                <>
                                <div className="">
                                    <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'branchcode', e.value)} value={filters.branchcode.value} optionLabel="label" optionValue="value" options={filters.branchcode.options} placeholder={$t('selectAValue')} >
                                    </Dropdown>
                                </div>
                                </>
                                }
                            </DataSource>
                        </div>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="p-3 mb-3">
                            <DataSource onLoad={(options) => setFilterOptions('groupid', options)}  apiPath="components_data/groupid_option_list_4"  >
                                {
                                ({ response }) => 
                                <>
                                <Title title={$t('filterByGroupid')}  headerClass="p-3" titleClass="font-bold text-primary" subTitleClass="text-sm text-500"      separator={false} />
                                <div className="">
                                    <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'groupid', e.value)} value={filters.groupid.value} optionLabel="label" optionValue="value" options={filters.groupid.options} placeholder={$t('selectAValue')} >
                                    </Dropdown>
                                </div>
                                </>
                                }
                            </DataSource>
                        </div>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="p-3 mb-3">
                            <DataSource onLoad={(options) => setFilterOptions('empcode', options)}  apiPath="components_data/empcode_sale_option_list"  >
                                {
                                ({ response }) => 
                                <>
                                <div className="">
                                    <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'empcode', e.value)} value={filters.empcode.value} optionLabel="label" optionValue="value" options={filters.empcode.options} placeholder={$t('selectAValue')} >
                                    </Dropdown>
                                </div>
                                </>
                                }
                            </DataSource>
                        </div>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="card  sp-3 mb-3">
                            <div className="">
                                <Calendar showIcon={true} showButtonBar={true} dateFormat="yy-mm-dd" hourFormat="24" className="w-full" selectionMode="range" value={filters.maturitydate.value} onChange={(e) => setFilterValue('maturitydate', e.value)} placeholder={$t('selectMaturityDate')}   />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="p-3 mb-3">
                            <div className="">
                                <Calendar showIcon={true} showButtonBar={true} dateFormat="yy-mm-dd" hourFormat="24" className="w-full" selectionMode="range" value={filters.date_closed.value} onChange={(e) => setFilterValue('date_closed', e.value)} placeholder={$t('selectCloseDate')}   />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        }
        <section className="page-section " >
            <div className="container-fluid">
                <div className="grid ">
                    <div className="col comp-grid" >
                        <FilterTags filterController={filterController} />
                        <div >
                            <PageBreadcrumbs />
                            <div className="grid ">
                                <div className="col">
                                    <div className="page-records">
                                        <DataTable 
                                            lazy={true} 
                                            loading={loading} 
                                            selectionMode="checkbox" selection={selectedItems} onSelectionChange={e => setSelectedItems(e.value)}
                                            value={records} 
                                            dataKey="policyno" 
                                            sortField={sortBy} 
                                            sortOrder={sortOrder} 
                                            onSort={onSort}
                                            className=" p-datatable-sm" 
                                            stripedRows={true}
                                            showGridlines={false} 
                                            rowHover={true} 
                                            responsiveLayout="stack" 
                                            emptyMessage={<EmptyRecordMessage />} 
                                            >
                                            {/*PageComponentStart*/}
                                            <Column selectionMode="multiple" headerStyle={{width: '2rem'}}></Column>
                                            <Column headerStyle={{width: '3rem'}} field=""  body={MasterDetailBtnTemplate}  ></Column>
                                            <Column  field="policyno" header={$t('policyno')} body={PolicynoTemplate} sortable={true} ></Column>
                                            <Column  field="memberid" header={$t('memberid')}  sortable={true} ></Column>
                                            <Column  field="depositlookup_membername" header={$t('membername')} body={MembernameTemplate}  ></Column>
                                            <Column  field="branchcode" header={$t('branchcode')}  sortable={true} ></Column>
                                            <Column  field="policydate" header={$t('policydate')} body={PolicydateTemplate} sortable={true} ></Column>
                                            <Column  field="deposite_type" header={$t('depositeType')}  sortable={true} ></Column>
                                            <Column  field="term" header={$t('term')}  sortable={true} ></Column>
                                            <Column  field="units" header={$t('units')}  sortable={true} ></Column>
                                            <Column  field="amount" header={$t('amount')}  sortable={true} ></Column>
                                            <Column  field="maturitydate" header={$t('maturitydate')} body={MaturitydateTemplate} sortable={true} ></Column>
                                            <Column  field="maturityamount" header={$t('maturityamount')}  sortable={true} ></Column>
                                            <Column  field="deduct_from_savings" header={$t('deductFromSavings')}  sortable={true} ></Column>
                                            <Column  field="empcode" header={$t('empcode')}  sortable={true} ></Column>
                                            <Column  field="depositlookup_empname" header={$t('empname')} body={EmpnameTemplate}  ></Column>
                                            <Column  field="ac_closed" header={$t('acStatusActiveClosed')} body={AcClosedTemplate} sortable={true} ></Column>
                                            <Column  field="created_by" header={$t('createdBy')}  sortable={true} ></Column>
                                            <Column  field="created_at" header={$t('createdAt')} body={CreatedAtTemplate} sortable={true} ></Column>
                                            <Column  field="updated_at" header={$t('updatedAt')} body={UpdatedAtTemplate} sortable={true} ></Column>
                                            <Column  field="updated_by" header={$t('updatedBy')}  sortable={true} ></Column>
                                            <Column  field="term_period" header={$t('termPeriod')}  sortable={true} ></Column>
                                            <Column  field="productid" header={$t('productid')} body={ProductidTemplate} sortable={true} ></Column>
                                            <Column  field="interest" header={$t('interest')}  sortable={true} ></Column>
                                            <Column  field="frequency" header={$t('frequency')}  sortable={true} ></Column>
                                            <Column  field="amort_type" header={$t('amortType')}  sortable={true} ></Column>
                                            <Column  field="compounding" header={$t('compounding')}  sortable={true} ></Column>
                                            <Column  field="groupid" header={$t('groupid')} body={GroupidTemplate} sortable={true} ></Column>
                                            <Column  field="date_closed" header={$t('dateClosed')}   ></Column>
                                            <Column  field="tran_type" header={$t('tranType')}   ></Column>
                                            <Column headerStyle={{width: '2rem'}} headerClass="text-center" body={ActionButton}></Column>
                                            {/*PageComponentEnd*/}
                                        </DataTable>
                                    </div>
                                    <PageFooter />
                                </div>
                                {
                                (currentRecord && !props.isSubPage) && 
                                <div className="col-12">
                                    <div className="card p-0">
                                        <MasterDetailPages masterRecord={currentRecord} scrollIntoView={true} />
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
	);
}
DepositesListPage.defaultProps = {
	primaryKey: 'policyno',
	pageName: 'deposites',
	apiPath: 'deposites/index',
	routeName: 'depositeslist',
	msgBeforeDelete: $t('promptDeleteRecord'),
	msgTitle: $t('deleteRecord'),
	msgAfterDelete: $t('recordDeletedSuccessfully'),
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: false,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 50,
}
export default DepositesListPage;
